import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import emitFallbackWarning from './emit-fallback-warning';

const increaseOpacity = ({
  targetColor,
  backgroundColor,
  opacity,
  condition,
  fallback,
  surfaceColor,
}) => {
  const { hue, saturation, lightness } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, opacity);

  let alpha = colorInstance.getAlpha();

  while (alpha <= 1) {
    colorInstance.setAlpha(+alpha.toFixed(2));
    const ratio = contrastRatio(backgroundColor, colorInstance, { surfaceColor });

    if (condition(ratio)) {
      return colorInstance;
    }

    alpha += 0.01;
  }

  emitFallbackWarning(
    `Cannot increase an opacity to reach proper contrast ratio between hsl(${targetColor.toColorString()}) and background color hsl(${backgroundColor.toColorString()})`,
    fallback
  );
  return new HSLColor(hue, saturation, lightness, 1);
};

export default increaseOpacity;
